import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLoanBalanceApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchLoanBalance = createAsyncThunk(
  "loanBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
 
      const payload = {
        accId:
          filters.filterType === "Loan Account Wise"
            ? filters?.accId || null
            : null,
        fromDate:
          filters.filterType === "Date Wise" ? filters?.fromDate || null : null,
        toDate:
          filters.filterType === "Date Wise" ? filters?.toDate || null : null,
      };
      const res = await getLoanBalanceApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchLoanAccountsBySearch = createAsyncThunk(
  "loanBalance/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        multiType: ["loan"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
